import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  Divider,
  Box,
} from "@mui/material";
import { ticketServices } from "../../services/AllServices";
import { Loader } from "../../components/CustomLoader";
import errorHandler from "../../utils/errorHandler";
import { capitalize } from "../../utils/helpers";
import { useEffect, useState } from "react";
import { PATH_URL } from "../../utils/constants";

const ViewTicket = ({ id, show, onHide }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const userData = async () => {
    try {
      setLoading(true);
      const response = await ticketServices.getById({ id });

      setData(response.data.data);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id && show) {
      userData();
    }
  }, [id, show]);

  return (
    <Dialog maxWidth="md" fullWidth open={show} onClose={onHide}>
      <DialogTitle>Ticket Details</DialogTitle>
      {loading ? (
        <Loader />
      ) : (
        <DialogContent dividers>
          <Grid container spacing={2}>
            {/* Row 1 */}
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Ticket Name:</Typography>
              <Typography>{capitalize(data?.name)}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Category:</Typography>
              <Typography>{capitalize(data?.category)}</Typography>
            </Grid>

            {/* Row 2 */}
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Ticket Status:</Typography>
              <Typography>{capitalize(data?.tickeStatus)}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Payment Status:</Typography>
              <Typography>{capitalize(data?.paymentStatus)}</Typography>
            </Grid>

            {/* Row 3 */}
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Auction Closed:</Typography>
              <Typography>{data?.isAuctionClosed ? "Yes" : "No"}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Price:</Typography>
              <Typography>${data?.price}</Typography>
            </Grid>

            {/* Row 4 */}
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Bid Start Price:</Typography>
              <Typography>${data?.bidPrice}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Total Tickets:</Typography>
              <Typography>{data?.totalTicket}</Typography>
            </Grid>

            {/* Row 5 */}
            {/* <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Available Tickets:</Typography>
              <Typography>{data?.availableTicket}</Typography>
            </Grid> */}
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Status:</Typography>
              <Typography>{capitalize(data?.status)}</Typography>
            </Grid>

            {/* Row 6 */}
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Search City:</Typography>
              <Typography>{data?.searchCity || '-'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Zipcode:</Typography>
              <Typography>{data?.zipcode || '-'}</Typography>
            </Grid>

            {/* Row 7 */}
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Venue:</Typography>
              <Typography>{data?.venue || '-'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Artist Name:</Typography>
              <Typography>{data?.artistName || '-'}</Typography>
            </Grid>

            {/* section */}
            <Grid item xs={6}>
              <Typography variant="subtitle2">Section:</Typography>
              <Typography>{data?.section || '-'}</Typography>
            </Grid>

            {/* row */}
            <Grid item xs={6}>
              <Typography variant="subtitle2">Row:</Typography>
              <Typography>{data?.row || '-'}</Typography>
            </Grid>

            {/* Address */}
            <Grid item xs={12}>
              <Typography variant="subtitle2">Full Address:</Typography>
              <Typography>{data?.fullAddress || '-'}</Typography>
            </Grid>


            {/* Description */}
            <Grid item xs={12}>
              <Typography variant="subtitle2">Description:</Typography>
              <Typography>{data?.description}</Typography>
            </Grid>
            {
              data?.event_start_date && <Grid item xs={12}>
                <Typography variant="subtitle2">Event Start Date:</Typography>
                <Typography>{new Date(data?.event_start_date).toLocaleString()}</Typography>
              </Grid>
            }


            {/* Timestamps */}
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Created At:</Typography>
              <Typography>
                {new Date(data?.createdAt).toLocaleString()}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Updated At:</Typography>
              <Typography>
                {new Date(data?.updatedAt).toLocaleString()}
              </Typography>
            </Grid>


            {/* Origin Info */}
            {data?.originIds?.length > 0 && (
              <Grid item xs={12}>
                <Typography variant="subtitle2">Origin Info:</Typography>
                {data.originIds.map((origin, index) => (
                  <Typography key={index} variant="body2">
                    • {origin.slug}
                  </Typography>
                ))}
              </Grid>
            )}

            {/* Image */}
            {data?.image && (
              <Grid item xs={6}>
                <Typography variant="subtitle2">Ticket Image:</Typography>
                <Box mt={1}>
                  <img
                    src={`${PATH_URL}${data.image}`}
                    alt="Ticket"
                    style={{ width: "100%", height: 300, borderRadius: 8 , objectFit: 'cover' }}
                  />
                </Box>
              </Grid>
            )}

            {/* Image */}
            {data?.venueImage && (
              <Grid item xs={6}>
                <Typography variant="subtitle2">Ticket Venue Image:</Typography>
                <Box mt={1}>
                  <img
                    src={`${PATH_URL}${data.venueImage}`}
                    alt="Ticket"
                    style={{ width: "100%", height: 300,  borderRadius: 8, objectFit: 'cover' }}
                  />
                </Box>
              </Grid>
            )}

          </Grid>

          <DialogActions sx={{ mt: 2 }}>
            <Button variant="outlined" onClick={onHide}>
              Close
            </Button>
          </DialogActions>
        </DialogContent>
      )}
    </Dialog>
  );
};

export default ViewTicket;
